import { featureCountryCode } from 'states/persistInStorage';
import { countryCodeToCountry } from 'utils/commonUtils';

export const getCountryForAzureQueryParam = () => {
  const countryCode = featureCountryCode() || undefined;
  return countryCodeToCountry(countryCode);
};

/**
 * Returns a function that reuses the same pending promise until it settles.
 *
 * Token refresh uses this to prevent parallel API requests from starting
 * competing refresh calls against the auth provider.
 */
export const cacheInFlightPromise = <T>(
  createPromise: () => Promise<T>
): (() => Promise<T>) => {
  let inFlight: Promise<T> | undefined;

  return () => {
    if (inFlight !== undefined) {
      return inFlight;
    }

    inFlight = createPromise().finally(() => {
      inFlight = undefined;
    });
    return inFlight;
  };
};
